<p-toast></p-toast>
<p-toast key="bottom-right" position="bottom-right"></p-toast>
